import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AdminSectionRegistryService } from '@brighthub/admin-contract';
import { Card } from 'primeng/card';

/**
 * Dashboard for the BrightNav admin subapp. Renders entries from {@link AdminSectionRegistryService}
 * so other packages can surface operations without coupling this template to their internals.
 */
@Component({
  selector: 'bn-brightnav-admin-home',
  standalone: true,
  imports: [Card, RouterLink],
  templateUrl: './brightnav-admin-home.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrightnavAdminHomeComponent {
  /** Catalog of feature-registered admin sections (suggestion chips, future modules, etc.). */
  protected readonly adminSections = inject(AdminSectionRegistryService);
}
